export default function FAQSection() {
  const faqs = [
    {
      question: 'yy漫画网上的韩漫真的是免费的吗？',
      answer: '是的！yy漫画网上的所有韩国漫画资源都完全免费。我们致力于为广大韩漫爱好者提供无障碍的阅读体验，无需注册会员，无需付费订阅，随时随地打开网站即可畅享下拉式韩漫阅读。',
    },
    {
      question: '什么是下拉式阅读？如何使用？',
      answer: '下拉式阅读是韩漫特有的一种阅读方式，适合在手机上使用。您只需像刷社交媒体一样上下滑动屏幕，漫画内容就会连续不断地呈现，无需翻页。这种方式让阅读体验更加流畅自然，非常适合长篇韩漫。',
    },
    {
      question: '网站上的漫画资源多久更新一次？',
      answer: '我们每天都会检查并更新漫画资源，确保您能看到最新的韩漫章节。热门连载漫画通常会在韩国更新后24小时内同步到我们的平台。您可以在"最新更新"栏目中查看每天新增的内容。',
    },
    {
      question: '支持哪些设备阅读？',
      answer: 'yy漫画网采用响应式设计，完美适配手机、平板和电脑。无论您使用什么设备，都可以获得优质的阅读体验。我们特别针对手机端进行了优化，确保下拉式阅读流畅顺滑。',
    },
    {
      question: '如何找到我想看的韩漫？',
      answer: '您可以通过多种方式找到心仪的漫画：在首页浏览推荐和热门排行，通过分类导航按题材筛选，或使用页面顶部的搜索功能。我们的分类系统涵盖恋爱、动作、奇幻、悬疑等多个类别，方便您快速定位。',
    },
    {
      question: '需要注册账号才能阅读吗？',
      answer: '不需要！yy漫画网无需注册即可免费阅读所有韩漫。我们相信好的内容应该被每个人轻松访问。如果您想保存阅读记录或收藏喜欢的漫画，可以考虑注册账号以获得更好的个性化体验。',
    },
  ];

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            常见<span className="text-accent-600">问题</span>
          </h2>
          <p className="text-sm text-foreground-500 mt-2">关于yy漫画网，你可能想知道的一切</p>
        </div>
        <div className="max-w-3xl mx-auto grid gap-4">
          {faqs.map((faq, index) => (
            <details key={index} className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors">
                <h4 className="text-sm font-semibold text-foreground-900 pr-4">{faq.question}</h4>
                <i className="ri-add-line text-foreground-400 group-open:hidden"></i>
                <i className="ri-subtract-line text-foreground-400 hidden group-open:block"></i>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}